export const assistantIntro =
    "Hello! I’m your PackageFlix assistant. Enter your question and submit — I’ll respond with a SQL query and results.";

export const feedbackPrompt = "Was this helpful?";

// Greeting
//const GREETING_RE = /^\s*(hi|hello|hey|hola|hiya|howdy|good\s*(morning|afternoon|evening))\b/i;
const GREETING_RE = /^\s*(h)\b/i;
export function isGreeting(text: string): boolean { return GREETING_RE.test(text || ""); }


